import DashboardView from "@/views/dashboard/DashboardView";

export default { DashboardView };
